import "@awesome.me/webawesome/dist/components/popover/popover.js";

import { startYuedu } from "./lianxi-yuedu-start.js";
import { settleFragment, startYueduWords } from "./yuedu-start.js";

/**
 * The script a reading passage's page loads.
 *
 * A bundle of its own, on the argument `main-bishun.ts` makes for the entry
 * page: the popover, the 生词 and the reading Exercise are on the `/yuedu/`
 * passages and nowhere else, and `<wa-popover>` brings `<wa-popup>` and its
 * positioning with it. `partials/lianxi/yuedu.html` loads it, as
 * `type="module"`, which defers, so the passage has been parsed by the time
 * this runs. The text and its questions are one page (CB-64), so this starts
 * both: `yuedu-start.ts` the words and `lianxi-yuedu-start.ts` the questions.
 * A page opened at `#questions` is brought back to them once the words are
 * marked (`settleFragment`).
 */
startYuedu(document);
void startYueduWords(document).then(() => {
  settleFragment(document);
});
